<template>
  <span class="bg-gray-500 text-gray-200 rounded-full p-1 px-3 text-xs">
    {{ badge }}
  </span>
</template>

<script setup lang="ts">
defineProps({
  badge: {
    type: [Number, String] as PropType<number | string>,
    required: true,
  },
})
</script>
